import ChangeReviewItem from './ChangeReviewItem';
import ChangeReviewJump from './ChangeReviewJump';
import ChangeReviewRemoved from './ChangeReviewRemoved';
import ChangeReviewSummary from './ChangeReviewSummary';

export type { ChangeKind, ChangeReviewItemProps } from './ChangeReviewItem';
export type { ChangeReviewJumpProps } from './ChangeReviewJump';
export type { ChangeReviewRemovedDetail, ChangeReviewRemovedProps } from './ChangeReviewRemoved';
export type { ChangeReviewSummaryProps } from './ChangeReviewSummary';

/**
 * Reviewing changes a machine made: one note per changed thing, a card for what it removed
 * outright, a bar counting what is still outstanding, and a chip pointing at any of it from
 * elsewhere on the page.
 */
export const ChangeReview = {
    Item: ChangeReviewItem,
    Summary: ChangeReviewSummary,
    Removed: ChangeReviewRemoved,
    Jump: ChangeReviewJump,
};

export default ChangeReview;
